import script from "./FeatureComparison.vue?vue&type=script&setup=true&lang=js"
export * from "./FeatureComparison.vue?vue&type=script&setup=true&lang=js"

import "./FeatureComparison.vue?vue&type=style&index=0&id=3ccc5423&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ccc5423"]])

export default __exports__